module.exports = __webpack_public_path__ + "img/Ensemble_rules_2024.81354472.png";